import { defineStore } from 'pinia';
import { ModuleContext } from './moduleConst';
import accountApi from '@/apis/auth/accountApi';
import authService from '@/commons/authService';
import { useDbOptionStore } from '@/stores/dbOptionStore';
import { computed } from 'vue';
import IndexedDB from '@/commons/indexedDB';

const state = {
  context: { token: '', sessionId: '', branch: 'ihos' },
  // Lưu trạng thái pre-auth khi user có đơn vị ở IGOV New (chưa tạo session đầy đủ)
  preAuthState: null,
};
const actions = {
  updateContext(context) {
    const remainingField = ['MisaIdAccessToken', 'MisaIdRefreshToken'];
    var oldContext = this.context.Context;
    const now = new Date();
    const expireDate = now.setSeconds(now.getSeconds() + context.expireSecond);
    context.tokenTimeout = expireDate;
    this.context = context;
    remainingField.forEach(item => {
      // update code - hqminh1 - 08/07/2026
      if (this.context.Context.hasOwnProperty(item) && oldContext.hasOwnProperty(item)){
        this.context.Context[item] = oldContext[item];
      }
    });
  },
  // Cập nhật token của context (nvthinh 17.04.2024)
  async updateToken(token, expiredToken, refreshToken) {
    if (token) {
      this.context.Token = token;
    }

    if (typeof expiredToken === 'string') {
      this.context.ExpiredToken = expiredToken;
    }

    if (refreshToken) {
      this.context.RefreshToken = refreshToken;
    }

    // Cập nhật lại thời gian đăng nhập khi refresh token (nvthinh 5.6.2024)
    if (this.context.Context && typeof this.context.Context === 'object') {
      this.context.Context.LoginDate = new Date();
    }
  },

  async refreshToken(context) {
    if (context) {
      this.context.token = context.token;
      this.context.refreshToken = context.refreshToken;
      const now = new Date();
      const expireDate = now.setSeconds(now.getSeconds() + context.expireSecond);
      context.tokenTimeout = expireDate;
    }
  },
  /**
   * Từ misaid sẽ gọi về callback api, trên api sẽ xử lý để chọn dữ liệu làm việc
   * Dựa theo phiên bản dữ liệu đó sẽ điều hướng về cụm api tương ứng và mã hóa thông tin user, database để truyền kèm
   * Client nhận dc token này sẽ gọi lên account api để đăng nhập
   */
  async loginCallback(payload) {
    const context = await accountApi.loginCallback(payload);

    // Nếu BE trả về pre-auth response (user có đơn vị IGOV New) → không set context bình thường
    if (context?.preAuthToken || context?.PreAuthToken) {
      return context;
    }

    const now = new Date();
    const expireDate = now.setSeconds(now.getSeconds() + context.expireSecond);
    context.tokenTimeout = expireDate;
    this.context = context;

    return context;
  },

  /**
   * Đăng xuất
   */
  async logout(path) {
    //Xóa cache về loại cán bộ trước khi logout nttung 10 30/3/2026
    const indexDB = new IndexedDB();

    const budgetCode = this.$state.context?.Context?.BudgetCode || 'default';
    const currentUnitType = this.$state.context?.Context?.UnitType || 0;
    const CACHE_KEY_EMPLOYEE_TYPES = `employee_types_${budgetCode}_${currentUnitType}`;

    var b = await indexDB.get(CACHE_KEY_EMPLOYEE_TYPES);
    await indexDB.delete(CACHE_KEY_EMPLOYEE_TYPES);

    authService.logout(path);
    sessionStorage.clear();
    localStorage.clear();
    this.Token = null;
    this.TokenExpired = null;
    this.User = null;
    this.context = null;
    this.MISAIDAccessToken = null;
    },
  async login(path) {
    authService.login(path);
  },
  async getMisaIdLink(payload) {
    try {
      return await accountApi.getMisaIdLink(payload);
    } catch (ex) {
      return null;
    }
  },

  async executeAfterLogin() {
    try {
      
      // Tạo promise với timeout 30 giây
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('Timeout after 30 seconds')), 30000);
      });

      // Race giữa API call và timeout
      let termsPrivacy = await Promise.race([accountApi.executeAfterLogin(), timeoutPromise]);
      // let termsPrivacy =  await   accountApi.executeAfterLogin();

      if (termsPrivacy && window._misaAgreementLib.IsActiveMisaAgreement) {
        this.context.Context.TermsPrivacy = termsPrivacy;
      }

      if (!this.context.Context.IsCompletedGettingStarted) {
        // cập nhật dboption nhắc nhở getting started
        // edit: cứ đăng nhập vào là nhắc (bỏ rule 7-15 ngày) => cập nhật dboption nhắc nhở getting started
        const dbOptionStore = useDbOptionStore();

        // cập nhật dboption nhắc nhở getting started
        await dbOptionStore.updateDbOption({
          option_name: 'is_remind_getting_started',
          option_value: 'false',
        });
      }
    } catch (ex) {
      console.log('executeAfterLogin error:', ex);
      // Nếu timeout hoặc lỗi khác, set termsPrivacy về null để tiếp tục làm việc
      if (this.context && this.context.Context) {
        this.context.Context.TermsPrivacy = null;
      }
    }
  },

  /**
   * Kiểm tra ngày có nhỏ hơn offsetDays ngày trở lên
   * vqphong - 27/07/2025
   */
  isDateOlderThanDays(dateString, offsetDays = 7) {
    // Reset cả hai ngày về 00:00:00 để chỉ so sánh ngày
    const inputDate = new Date(dateString);
    inputDate.setHours(0, 0, 0, 0);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const offsetDaysAgo = new Date(today);
    offsetDaysAgo.setDate(today.getDate() - offsetDays);

    return inputDate <= offsetDaysAgo;
  },
  /**
   * Cập nhật trạng thái đã mua các app riêng lẻ từ trước
   * @param {*} payload
   */
  updateAllocateStatusApps(payload) {
    this.$state.context.Context.IsAlreadyBuyQlcb = payload?.IsAlreadyBuyQlcb || false;
    this.$state.context.Context.IsAlreadyBuyMimosa = payload?.IsAlreadyBuyMimosa || false;
    this.$state.context.Context.IsAlreadyBuyBumas = payload?.IsAlreadyBuyBumas || false;
    this.$state.context.Context.IsAlreadyBuySalagov = payload?.IsAlreadyBuySalagov || false;
    this.$state.context.Context.IsAlreadyBuyQlts = payload?.IsAlreadyBuyQlts || false;
  },
  updateCompleteGettingStarted() {
    this.$state.context.Context.IsCompletedGettingStarted = true;
  },
  /**
   * Xây dựng URL ảnh avatar từ CDN
   * @returns {string} URL đầy đủ của avatar từ CDN
   * @author nvthinh 06.12.2025
   */
  buildAvatarSrc() {
    const budgetCode = this.$state.context?.Context?.BudgetCode;
    if (!budgetCode) {
      console.error('Budget code is not found');
      return '';
    }

    const misaId = this.$state.context?.user?.user_id;
    if (!misaId) {
      console.error('MisaId is not found');
      return '';
    }

    const cdnUrl = window.cdnUrl || '';
    const avatarEndpoint = window._apis?.AvatarEndpoint;
    const avatarId = this.$state.context?.user?.avatar_id || '';

    return `${cdnUrl}${avatarEndpoint}/${budgetCode}/${misaId}/${avatarId}`;
  },

  /**
   * Lưu trạng thái pre-auth sau khi BE trả về preAuthToken + tenants.
   * @param {{ preAuthToken: string, tenants: Array }} state
   */
  setPreAuthState(state) {
    this.preAuthState = state;
  },

  clearPreAuthState() {
    this.preAuthState = null;
  },
};
const getters = {};

export const useContextStore = defineStore(ModuleContext, {
  state: () => state,
  actions,
  getters: getters,
  persist: {
    beforeRestore: (ctx, action) => { },
    afterRestore: (ctx, action) => { },
    debug: true,
  },
});
